import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Footer from "../../components/footer";
import Header from "../../components/header";
import PrivacyCard from "../../components/privacyCard";
import { getExtrasContent } from "../../services/api";
import LoadingSpinner from "../../components/common/LoadingSpinner";

export default function DynamicPolicy() {
  const { key } = useParams();
  const navigate = useNavigate();
  const [content, setContent] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchContent = async () => {
      try {
        setLoading(true);
        setError(null);
        
        const data = await getExtrasContent(key);
        
        // Backend'den gelen veriyi PrivacyTemplate formatına dönüştür
        const formattedContent = {
          titleBlue: data.title || "Politika",
          sections: [
            {
              type: "html",
              content: data.content || ""
            }
          ]
        };
        
        setContent(formattedContent);
      } catch (err) {
        console.error("İçerik yüklenirken hata:", err);
        setError(err.message || "İçerik yüklenirken bir hata oluştu");
      } finally {
        setLoading(false);
      }
    };

    if (key) {
      fetchContent();
    }
  }, [key]);

  // Sayfa yüklendiğinde en üste scroll et
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [key]);

  if (loading) {
    return (
      <div className="flex flex-col min-h-screen bg-white">
        <Header isHomePage={false} />
        <div className="flex-1 flex items-center justify-center">
          <LoadingSpinner />
        </div>
        <Footer isHomePage={false} />
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex flex-col min-h-screen bg-white">
        <Header isHomePage={false} />
        <div className="flex-1 flex items-center justify-center">
          <div className="text-center">
            <h2 className="text-2xl font-bold text-gray-800 mb-4">
              İçerik Bulunamadı
            </h2>
            <p className="text-gray-600 mb-6">{error}</p>
            <button
              onClick={() => navigate("/")}
              className="bg-[#FCB8C4] text-white px-6 py-2 rounded-lg hover:bg-[#f8a5b3] transition-colors"
            >
              Ana Sayfaya Dön
            </button>
          </div>
        </div>
        <Footer isHomePage={false} />
      </div>
    );
  }

  if (!content) {
    return (
      <div className="flex flex-col min-h-screen bg-white">
        <Header isHomePage={false} />
        <div className="flex-1 flex items-center justify-center">
          <div className="text-center">
            <h2 className="text-2xl font-bold text-gray-800 mb-4">
              İçerik Bulunamadı
            </h2>
            <p className="text-gray-600 mb-6">
              Aradığınız içerik mevcut değil.
            </p>
            <button
              onClick={() => navigate("/")}
              className="bg-[#FCB8C4] text-white px-6 py-2 rounded-lg hover:bg-[#f8a5b3] transition-colors"
            >
              Ana Sayfaya Dön
            </button>
          </div>
        </div>
        <Footer isHomePage={false} />
      </div>
    );
  }

  return (
    <div className="flex flex-col min-h-screen bg-white">
      {/* Header */}
      <Header isHomePage={false} />

      {/* Hero Section - PrivacyTemplate ile aynı responsive tasarım */}
      <section className="relative w-full h-[220px] sm:h-[220px] md:h-[440px] lg:h-[440px] xl:h-[400px] 2xl:h-[500px] overflow-hidden">
        <div className="absolute inset-0 flex items-end bg-[#FCB8C4]">
          <div className="container mx-auto px-4 sm:px-6 md:px-8 lg:px-10 xl:px-28 2xl:px-32 pb-4 sm:pb-8 md:pb-12 lg:pb-16 xl:pb-20 2xl:pb-24">
            <h2 className="text-3xl sm:text-3xl md:text-[42px] lg:text-[48px] xl:text-[54px] 2xl:text-[60px] font-bold font-poppins text-white text-start sm:text-left max-w-xs sm:max-w-sm md:max-w-2xl lg:max-w-3xl xl:max-w-4xl mx-auto sm:mx-0">
              {content.titleBlue}
            </h2>
          </div>
        </div>
      </section>

      {/* Content Section */}
      <section className="container mx-auto px-4 sm:px-6 py-8 sm:py-12 md:py-16 lg:py-20">
        <div className="max-w-full sm:max-w-4xl md:max-w-5xl lg:max-w-6xl xl:max-w-7xl mx-auto">
          {content.sections.map((section, index) => (
            <PrivacyCard
              key={index}
              type={section.type}
              content={section.content}
              textSize="text-xl"
            />
          ))}
        </div>
      </section>

      {/* Footer */}
      <Footer isHomePage={false} />
    </div>
  );
} 